import { CourseRowData } from '../utils/librarydata';
import { apiRequest } from './http';

export interface LibraryResponse {
  success?: boolean;
  message?: string;
  data?: CourseRowData[];
}

export function getLibraryRows(): Promise<LibraryResponse> {
  return apiRequest<LibraryResponse>({
    endpoint: '/library',
    method: 'GET',
  });
}
